import React, { useState, useEffect } from "react";
import grey from "@material-ui/core/colors/grey";
import StopSharpIcon from "@material-ui/icons/StopSharp";
import PropTypes from "prop-types";
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from "@material-ui/core/Button";
import {
  withStyles,
  makeStyles,
  createStyles,
  useTheme,
} from "@material-ui/core/styles";
import clsx from "clsx";
import Box from "@material-ui/core/Box";
import {
  FormHelperText,
  Input,
  InputLabel,
  InputBase,
} from "@material-ui/core";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Checkbox from "@material-ui/core/Checkbox";
import {
  DatePicker, KeyboardDatePicker
} from '@material-ui/pickers';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { reportFilterFuel } from "./ReportObj";
import { ToastError } from "../../services/ToastMsg";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  borderRight: {
    borderRight: "1px solid " + grey[400],
  },
  MuiButtonBaseRoot: {
    borderRadius: 4,
    padding: 0,
    paddingBottom: "2px",
    color: grey[400],
  },
  MuiSvgIconRoot: {
    color: "#ff4717",
    border: "2px solid " + grey[400],
    fontSize: "1.3rem",
    borderRadius: 3,
  },
  anchorTag: {
    textDecoration: "none",
    cursor: "pointer",
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
  },
}));
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "auto",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);

const BootstrapDate = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(2),
    },
  },

  input: {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.common.white,
    border: "1px solid #ced4da",
    fontSize: 16,
    width: "100%",
    padding: "10px 12px",
    height: "0.1876em",
    // marginLeft: '2.2em',
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      // boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      borderColor: theme.palette.primary.main,
    },
  },
}))(InputBase);
export default function FiltersReportFuel(props) {
  const classes = useStyles();
  const [filter, setFilter] = React.useState(true);
  const [selectedStartDate, handleStartChange] = useState(new Date());
  const [selectedEndDate, handleEndChange] = useState(new Date());

  const [formObj, setFormObj] = useState(reportFilterFuel);
  const [selectedValue, setSelectedValue] = React.useState('All');
  const { filterReportFual } = props;
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  };

  const onChangeText = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value });
  };
  const onChangeStatus = (event) => {
    setFormObj({ ...formObj, [event.target.name]: event.target.value === "Active" ? true : false });
  };
  const applyFilter = () =>{
    
      filterReportFual(formObj);
    
  };
  const handleDateData = (event, type) => {
    let dateFormat = "";
    if(event){
       dateFormat = event.format('YYYY-MM-DD');
    }
    setFormObj({ ...formObj, [type]: dateFormat });
    // ////console.log(event, type);
  }
  return (
    <div>
      <Box
        component="div"
        px={1}
        pt={1.2}
        pb={1}
        display="flex"
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
        <Box component="h2" m={0} className="blcopy" fontWeight="500" pl={2}>
          Filters:
        </Box>
      </Box>
      <Box
        component="div"
        px={1}
        pt={1}
        pb={2}
        display={filter ? "flex" : "none"}
        className={clsx(
          classes.justifyContentBetween,
          classes.alignItemsStretch
        )}
      >
        <Grid container spacing={3} className="reports-filter-row" >
          <Grid className="reports-filter-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Lab
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled
                  />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Asset
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Client Contract
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="contract"
                    value={formObj.contract || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label" >
                  Vessel IMO
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="vessel"
                    value={formObj.vessel || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid className="reports-filter-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Bunker Port
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="bunkerPort"
                    value={formObj.bunkerPort || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Fuel Supplier
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Fuel Grade
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label" >
                  Offspec Results
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid className="reports-filter-col report-date-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Bunkered Qty Range in MT
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  ISO Specification
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                py={1}

              >
                <Box component="label" >
                  Bunkered Date
            </Box>
                {/* <Box component="div">
              <BootstrapInput />
            </Box> */}
                <Box component="span" className=" date-input pad-right-1"   >

                  <KeyboardDatePicker

                    margin="normal"
                    id="date-picker-dialog"
                    // label="Date picker dialog"
                    format="DD/MM/yyyy"
                    invalidDateMessage="" 
                    value={formObj.bunkeredFromDate || ""}
                    onChange={(event)=>{handleDateData( event, "bunkeredFromDate")}}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />

                </Box>
                <Box component="span" className=" date-input" mr="2"  >
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    // label="Date picker dialog"
                    format="DD/MM/yyyy"
                    invalidDateMessage="" 
                    value={formObj.bunkeredToDate || ""}
                    onChange={(event)=>{handleDateData( event, "bunkeredToDate")}}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
              >
                <Box component="label"  >
                  Sampled Date
            </Box>
                <Box component="span" className="date-input pad-right-1 "   >

                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    // label="Date picker dialog"
                    format="DD/MM/yyyy"
                    invalidDateMessage="" 
                    value={formObj.sampledFromDate || ""}
                    onChange={(event)=>{handleDateData(event, "sampledFromDate")}}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Box>
                <Box component="span" className="date-input  "  >
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    // label="Date picker dialog"
                    format="DD/MM/yyyy"
                    invalidDateMessage="" 
                    value={formObj.sampledToDate || ""}
                    onChange={(event)=>{handleDateData(event, "sampledToDate")}}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid className="reports-filter-col">
            <Box
              component="div"
              className="reports-filter"
              pl={2}
            >
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                pb={3}
              ></Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Sample Number
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="sampleNumber"
                    value={formObj.sampleNumber || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Barge Name
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput disabled />
                </Box>
              </Box>
              <Box
                component="div"
                display="flex"
                className="re-filter-input"
                pb={1}
              >
                <Box component="label"  >
                  Report Type
            </Box>
                <Box component="div" className="re-filter-box">
                  <BootstrapInput name="reportType"
                    value={formObj.reportType || ""}
                    onChange={onChangeText} />
                </Box>
              </Box>
            </Box>
          </Grid>
          <Grid className="reports-filter-col reports-status-col">
            <Box component="div">
              <Box
                component="div"
                display="flex"
                className={classes.justifyContentBetween}
                alignItems="flex-end"
                height={1}
              >
                <Box component="div" width={1} display="block" className="report-status">
                  <Box
                    component="div"
                    fontWeight="bold"

                    display="flex" className="blcopy"
                    pb={1}
                    pt={3}
                  >
                    Report Status
              </Box>
                  <Box
                    component="div"
                    display="block"
                    className={classes.justifyContentBetween + " reports-radio"}
                  >
                    
                  <RadioGroup
                    row
                    aria-label="position"
                    name="statusType"
                    defaultValue="top"
                    value={formObj.statusType}
                    onChange={onChangeText}
                  >
                    <Box component="div" alignItems="center" width={1} display="block">
                      <FormControlLabel value="All"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block" >
                        {"All"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Critical"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                      {"Critical"}
                  </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Warning"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Warning"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Satisfactory"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1}  display="inlin-block">
                        {"Satisfactory"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                       <FormControlLabel value="Other"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Other"}
                      </Box>
                    </Box> 
                  </RadioGroup>
                  {/* <RadioGroup
                    row
                    aria-label="position"
                    name="status"
                    defaultValue="top"
                    value={formObj.status}
                    onChange={onChangeText}
                  >
                    <Box component="div" alignItems="center" width={1} display="block">
                      <FormControlLabel value="All"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block" >
                        {"All"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value=" With Specification"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                       With Specification
                  </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value="Warning"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"Warning"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                      <FormControlLabel value=" Off Specification"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1}  display="inlin-block">
                        {" Off Specification"}
                      </Box>
                    </Box>
                    <Box component="div" alignItems="center" width={1}  display="block">
                       <FormControlLabel value="other"  control={<Radio className={classes.radioInput} />}
                      labelPlacement="start" />
                      <Box component="span" ml={1} display="inlin-block"  >
                        {"other"}
                      </Box>
                    </Box>
                  </RadioGroup> */}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>

      </Box>
      <Box component="div" >
        <Grid container spacing={3}  className="reports-filter-row" >
          <Grid className="reports-apply-filter-btn">
            <Button type="button" onClick={applyFilter} className={classes.btnStyle2}>
              Apply Filter
            </Button>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
